import React from "react";
import { Toaster } from "react-hot-toast";
import { Outlet } from "react-router-dom";

import Content from "../components/Content";
import Footer from "../components/Footer";
import Main from "../components/Main";
import Wrapper from "../components/Wrapper";

const Images = ({ children }) => {
  return (
    <React.Fragment>
      <Wrapper>
        <Main>
          <Content>
            <Toaster />
            {children}
            <Outlet />
          </Content>
          <Footer />
        </Main>
      </Wrapper>
    </React.Fragment>
  );
};

export default Images;
